module.exports = __webpack_public_path__ + "static/media/connections-icon.d3464903.svg";